import { withFormsy } from 'formsy-react';
import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'twyne-new.ui';
import moment from 'moment';
import 'moment-timezone';
import { sortBy } from 'lodash';

class SelectTimeZone extends React.Component {
  timeZones () {
    const timeZones = moment.tz.names();
    const offsetTmz = [];

    for (const i in timeZones) {
      const tz = moment.tz(timeZones[i]).format('Z').replace(':00', '').replace(':30', '.5');
      let x = (tz === 0) ? 0 : parseInt(tz, 10).toFixed(2);

      const timeZone = {
        label: `(GMT${moment.tz(timeZones[i]).format('Z')}) ${timeZones[i]}`,
        value: `${timeZones[i]}`,
        time: `${x}`
      };
      offsetTmz.push(timeZone);
    }

    return sortBy(offsetTmz, [function (el) { return -(el.time) }]);
  }

  render () {
    const selectOptions = this.timeZones();
    const { setValue, getValue, name, isValid, isPristine, isRequired } = this.props;
    const isInvalidClass = !isValid() && !isPristine() ? 'is-invalid' : '';

    return (
      <>
        <Select
          name={name}
          value={getValue()}
          onChange={option => setValue(option ? option.value : null)}
          options={selectOptions}
          required={this.props.required}
          className={`form-control border-0 p-0 ${isInvalidClass}`}
        />
        <span className="invalid-feedback">
          {isRequired() && !getValue() && ' Field required'}
        </span>
      </>
    );
  }
}

SelectTimeZone.propTypes = {
  setValue: PropTypes.func,
  getValue: PropTypes.func,
  name: PropTypes.string
};

export default withFormsy(SelectTimeZone);
